<template lang="pug">
    Coverking(
        v-if="integration.type === 'COVERKING'"
        :params="integration.params"
    )
    Saddleman(
        v-else-if="integration.type === 'SADDLEMAN'"
        :params="integration.params"
    )
    Northwest(
        v-else-if="integration.type === 'NORTHWEST'"
        :params="integration.params"
    )
    Covercraft(
        v-else-if="integration.type === 'COVERCRAFT'"
        :params="integration.params"
    )
    TigerTough(
        v-else-if="integration.type === 'TIGERTOUGH'"
        :params="integration.params"
    )
    iframe(
        v-else
        :src="iframeUrl"
        width="100%"
        height="900"
    )
</template>

<script>
const Coverking = () => import(/* webpackChunkName: "third-party-coverking" */ './coverking')
const Covercraft = () => import(/* webpackChunkName: "third-party-covercraft" */ './covercraft')
const Saddleman = () => import(/* webpackChunkName: "third-party-saddleman" */ './saddleman')
const Northwest = () => import(/* webpackChunkName: "third-party-northwest" */ './northwest')
const TigerTough = () => import(/* webpackChunkName: "third-party-northwest" */ './tigerTough')
export default {
    name: 'ThirdPartyIndex',
    components: {
        Coverking,
        Saddleman,
        Northwest,
        Covercraft,
        TigerTough,
    },
    props: {
        integration: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        iframeUrl() {
            return `/third-party/${this.integration.type}/?params=${JSON.stringify(
                this.integration
            )}&disableIntegration=all`
        },
    },
}
</script>
